import { FileText, Download } from "lucide-react";
import { API } from "@/lib/api";
import { useT } from "@/lib/i18n";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");

export function InvoiceList({ invoices }) {
  const { t } = useT();
  return (
    <div data-testid="invoice-list" className="glass rounded-2xl overflow-hidden">
      <div className="p-4 border-b border-white/10 font-display font-semibold text-sm flex items-center gap-2"><FileText size={15} className="text-cyan-400" /> {t("Invoices & receipts")}</div>
      {invoices.length === 0 && <div data-testid="invoice-empty" className="p-5 text-xs text-slate-500 font-mono">{t("No approved payments yet.")}</div>}
      {invoices.length > 0 && (
        <table className="w-full text-sm">
          <thead><tr className="text-[10px] font-mono uppercase text-slate-500 border-b border-white/10">
            <th className="text-left px-4 py-2">{t("Invoice")}</th><th className="text-left px-4 py-2">{t("Pack")}</th><th className="text-left px-4 py-2 hidden sm:table-cell">{t("Date")}</th><th className="text-left px-4 py-2">{t("Amount")}</th><th className="px-4 py-2" />
          </tr></thead>
          <tbody>
            {invoices.map((o, i) => (
              <tr key={o.order_id} data-testid={`invoice-row-${i}`} className="border-b border-white/5">
                <td className="px-4 py-2.5 font-mono text-xs text-purple-300">{o.invoice_no || o.order_id}</td>
                <td className="px-4 py-2.5">{o.pack_name}</td>
                <td className="px-4 py-2.5 text-xs text-slate-400 hidden sm:table-cell">{fmtDate(o.approved_at)}</td>
                <td className="px-4 py-2.5 font-mono">₹{o.amount.toLocaleString("en-IN")}</td>
                <td className="px-4 py-2.5 text-right">
                  <a data-testid={`invoice-download-${i}`} href={`${API}/billing/orders/${o.order_id}/invoice.pdf`} target="_blank" rel="noreferrer"
                    className="inline-flex items-center gap-1 text-xs text-cyan-300 hover:underline"><Download size={12} /> PDF</a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
